import { DEFAULT_UUID_NAME_LIST } from './../utils/utils';

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { LocationControllerApi } from "../services";
import {
    getConfigObject,
    useBaseData
} from "../utils/utils";

interface UseProviderGroupListProps {
    searchString?: string,
    xTENANTID?: string,
    enabled?: boolean;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export function useLocationOptionsV2({
    searchString,
    xTENANTID,
    enabled = true,
}: UseProviderGroupListProps): useBaseData<typeof DEFAULT_UUID_NAME_LIST> {
    return useQuery({
        queryKey: [
            "provider-group-location-list-v2",
            searchString, xTENANTID
        ],
        placeholderData: keepPreviousData,
        refetchOnWindowFocus: false,
        enabled: enabled,
        queryFn: async () =>
            new LocationControllerApi(getConfigObject())
                .getLocation(
                    searchString, xTENANTID
                )
                .then((resp) => resp?.data)
    });
}
